export default __webpack_public_path__ + "static/media/circle_graph_red.40bc14e5.svg";